import PrimaryPageContainer from "../components/containers/PrimaryPageContainer.jsx";
import AdminValidateContentSection from "../sections/AdminValidateContentSection.jsx";

function AdminValidatePage() {
  return (
    <PrimaryPageContainer>
      <AdminValidateContentSection />
    </PrimaryPageContainer>
  );
}

export default AdminValidatePage;
